import React, { useCallback, useMemo, useState, useEffect, useContext } from "react";
import Dropdown, { OPTION_DISPLAY } from "@acadia-ui/dropdown";
import { ToolbarContext } from "@acadia-ui/toolbar";
import { shouldFilter } from "../utils";

const draftStatusOptions = [
	{ label: "Draft", value: "draft" },
	{ label: "Active", value: "active" }
];

export default function useDraftStatusDropdown({ isOpen, prefix }) {
	const context = useContext(ToolbarContext);
	const [value, setValue] = useState([]);

	useEffect(() => {
		if (isOpen) {
			if (shouldFilter(`${prefix}-filter-draftStatus`, context?.filterValues)) {
				setValue(
					Object.entries(context?.filterValues?.[`${prefix}-filter-draftStatus`])
						?.filter(([_, value]) => value)
						?.map(([id]) => draftStatusOptions?.find(({ value }) => value === id))
						?.filter(Boolean)
				);
			}
		} else {
			setValue([]);
		}
		// Intentionally exclude context from deps array as we only want to rerender when isOpen changes to true
	}, [isOpen, prefix]);

	const handleOnChange = useCallback((values) => {
		setValue(values);
	}, []);

	return useMemo(() => {
		return {
			element: (
				<Dropdown
					className={"gos-pm-filters-sidesheet-draft-status-dropdown"}
					multiple
					display={OPTION_DISPLAY.PILL_INLINE}
					value={value}
					options={draftStatusOptions}
					placeholder={"Select a Status"}
					onChange={handleOnChange}
					isClearable={true}
				>
					Draft Status
				</Dropdown>
			),
			value,
			setValue
		};
	}, [value, handleOnChange]);
}
